import React from 'react';
import '../components/Navigation.css';

const Footer = () => {
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Spot Free Clarity</h3>
            <p>Professional window cleaning services in Somerset West, South Africa.</p>
          </div>
          <div className="footer-section">
            <h3>Contact Info</h3>
            <p>📍 Somerset West, South Africa</p>
            <p>📧 <a href="mailto:info@spotfreeclarity.co.za">info@spotfreeclarity.co.za</a></p>
            <p>📱 Call us for a quote</p>
          </div>
          <div className="footer-section">
            <h3>Quick Links</h3>
            <p><a href="/">Home</a></p>
            <p><a href="/about">About</a></p>
            <p><a href="/contact">Contact</a></p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Spot Free Clarity. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
